import TruckCompatibilityItem from "./TruckCompatibilityItem.jsx";

export default function TruckCompatibilityGroup({
  context,
  interactionsDisabled = false,
  onReassign,
  selectedDeliveryId = null,
  showHeader = true,
  showRouteImpact = false,
}) {
  const compatibilities = Array.isArray(context?.compatibilities)
    ? context.compatibilities
    : [];
  const currentAssignmentSummary = context?.current_assignment_summary;
  const isSelectedContext = Boolean(
    selectedDeliveryId
    && context?.delivery_id
    && context.delivery_id === selectedDeliveryId,
  );

  return (
    <section
      className={[
        "grid rounded-lg border shadow-card transition-colors",
        showRouteImpact ? "gap-px p-0.5" : "gap-1.5 p-1.5",
        isSelectedContext
          ? "border-border-accent-strong bg-[rgba(235,239,240,0.98)] shadow-[0_0_0_1px_rgba(15,92,87,0.08)]"
          : "border-line-soft bg-[rgba(236,239,241,0.94)]",
      ].join(" ")}
      data-react-compatibility-group="true"
    >
      {showHeader ? (
        <header className="flex flex-wrap items-center gap-2 px-1 pt-0.5">
          <div className="min-w-0 flex-1">
            <strong className="block truncate font-display text-base font-semibold text-text">
              {context?.client_name ?? "Client"}
            </strong>
          </div>
          {context?.is_manual ? (
            <span className="rounded-full bg-amber-soft px-2.5 py-1 text-[0.68rem] font-semibold uppercase tracking-[0.12em] text-amber">
              Manuel
            </span>
          ) : null}
        </header>
      ) : null}
      {compatibilities.length ? (
        <ul className={[
          "m-0 flex list-none flex-col p-0",
          showRouteImpact ? "gap-px" : "gap-2.5",
        ].join(" ")}>
          {compatibilities.map((compatibility) => (
            <TruckCompatibilityItem
              key={`${context?.delivery_id ?? "delivery"}-${compatibility?.truck_id ?? "truck"}`}
              compatibility={compatibility}
              currentAssignmentSummary={currentAssignmentSummary}
              deliveryId={context?.delivery_id ?? null}
              interactionsDisabled={interactionsDisabled}
              onSelect={onReassign}
              showRouteImpact={showRouteImpact}
            />
          ))}
        </ul>
      ) : (
        <div className="rounded-lg border border-line-soft bg-[rgba(240,242,244,0.98)] px-3 py-2 text-sm text-muted-strong">
          Aucun camion compatible n'est disponible dans la vue rapide pour cette ferme.
        </div>
      )}
    </section>
  );
}
